// extracted by mini-css-extract-plugin
export default {"container":"ManageAssetApproval_container__Vn-qY"};